/* global localStorage */

import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/pages/Home.vue'
import Packages from '@/pages/packages/Packages.vue'
import Package from '@/pages/packages/Package.vue'
import SignIn from '@/pages/auth/SignIn.vue'
import SignOut from '@/pages/auth/SignOut.vue'
import PasswordReset from '@/pages/auth/PasswordReset.vue'
import NewPassword from '@/pages/auth/NewPassword.vue'
import ChangePassword from '@/pages/auth/ChangePassword.vue'
import ConfirmPasswordReset from '@/pages/auth/ConfirmPasswordReset.vue'
import ManageApiKeys from '@/pages/auth/ManageApiKeys.vue'
import PageNotFound from '@/pages/PageNotFound.vue'
import CubejsApi from '@/pages/CubejsApi.vue'

// Dashboards
import Dashboard from '@/pages/Dashboard.vue'

import store from '@/store'

Vue.use(Router)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: { title: 'Home DLT', auth: true }
  },
  {
    path: '/d-data-catalog',
    name: 'dataCatalog',
    redirect: { name: 'packages' }
  },
  {
    path: '/d-data-catalog/packages',
    name: 'packages',
    component: Packages,
    meta: { title: 'Pacchetti', auth: true }
  },
  {
    path: '/sign-in',
    name: 'signIn',
    component: SignIn,
    meta: { title: 'Accesso', auth: false }
  },
  {
    path: '/new-password',
    name: 'newPassword',
    component: NewPassword,
    meta: { title: 'Nuova password', auth: true }
  },
  {
    path: '/profile/change-password',
    name: 'changePassword',
    component: ChangePassword,
    meta: { title: 'Cambio password', auth: true }
  },
  {
    path: '/profile/manage-api-keys',
    name: 'manageApiKeys',
    component: ManageApiKeys,
    meta: { title: 'Gestione API', auth: true }
  },
  {
    path: '/profile/sign-out',
    name: 'signOut',
    component: SignOut,
    meta: { title: 'Logout', auth: true }
  },
  {
    path: '/password-reset',
    name: 'passwordReset',
    component: PasswordReset,
    meta: { title: 'Reset password', auth: false }
  },
  {
    path: '/confirm-password-reset',
    name: 'confirmPasswordReset',
    component: ConfirmPasswordReset,
    meta: { title: 'Conferma reset password', auth: false }
  },
  {
    path: '/d-data-catalog/package/:id',
    name: 'getPackageById',
    component: Package,
    meta: { title: 'Dettagli pacchetti', auth: true }
  },
  {
    path: '/d-wikipedia',
    name: 'wikipedia',
    component: Dashboard,
    meta: { title: 'Wikipedia', auth: true, url: 'wikipedia/' }
  },
  {
    path: '/analytics-2-livello/d-opinion-mining',
    name: 'opinionMining',
    component: Dashboard,
    meta: { title: 'Opinion Mining', auth: true, url: 'analytics/#/opinion-mining' }
  },
  {
    path: '/analytics-2-livello/d-twittersfera',
    name: 'twittersfera',
    component: Dashboard,
    meta: { title: 'Twittersfera', auth: true, url: 'dash/twittersphere' }
  },
  {
    path: '/analytics-2-livello/d-communities-topics',
    name: 'communityTopics',
    component: Dashboard,
    meta: { title: 'Community & Topics', auth: true, url: 'dash/communities-topics' }
  },
  {
    path: '/analytics-2-livello/d-peak-detection',
    name: 'peakDetection',
    component: Dashboard,
    meta: { title: 'Peak Detection', auth: true, url: 'dash/peak-detection' }
  },
  {
    path: '/cubejs-api',
    name: 'cubejsApi',
    component: CubejsApi,
    meta: { title: 'API', auth: true }
  },
  {
    path: '/statistiche-sardegna/d-destinations',
    name: 'destinations',
    component: Dashboard,
    meta: { title: 'Booking Destinations 2018', auth: true, url: 'analytics/#/destinations/booking/2019' }
  },
  {
    path: '*',
    component: PageNotFound,
    meta: { title: 'Errore 404 - Pagina non trovata' }
  }
]

const router = new Router({ mode: 'history', routes })

// this routine will ensure that any pages marked as `auth` in the `meta` section are
// protected from access by unauthenticated users.
router.beforeEach(async (to, from, next) => {
  // Use the page's router title to name the page
  if (to.meta && to.meta.title) {
    document.title = to.meta.title
  }

  // is there a meta and auth attribute?
  if (to.meta && to.meta.auth !== undefined) {
    // if the page requires auth
    if (to.meta.auth) {
      // and we are authenticated?
      if (store.getters['auth/isAuthenticated']) {
        next() // route normally
        return
      }
      // otherwise off to the sign in page
      router.push({ name: 'signIn' }).catch(err => console.error(err))
      return
    }
    // otherwise are we already authenticated?
    if (store.getters['auth/isAuthenticated']) {
      const returnTo = localStorage.getItem('returnTo')

      if (returnTo) {
        localStorage.removeItem('returnTo')
        await store.dispatch('auth/signOut')
        router.push({ name: 'signIn', params: { returnTo } }).catch(err => console.error(err))
        return
      }

      router.push({ name: 'home' }).catch(err => console.error(err))
      return
    }
    next() // route normally
    return
  }
  next() // route normally
})

export default router
